export default __webpack_public_path__ + "static/media/landing_bg.40abb677.png";